import basic from "../../../data/basic.yaml";
import top from "../../../data/top.yaml";
import news from "../../../data/news.yaml";
import career from "../../../data/career.yaml";
import education from "../../../data/education.yaml";
import research from "../../../data/research.yaml";
import creation from "../../../data/creation.yaml";
import award from "../../../data/award.yaml";
import others from "../../../data/others.yaml";
import sns from "../../../data/sns.yaml";
import menu from "../../../data/menu.yaml";
import abbr from "../../../data/abbr.yaml";
import pubs from "../../../data/pubs.yaml";
import publication from "../../../data/pubs-ui.yaml";
import academicLinks from "../../../data/academicLinks.yaml";
import talks from "../../../data/talks.yaml";

import type {
  AcademicLink,
  AwardData,
  AbbrData,
  BasicData,
  CareerItem,
  CreationItem,
  EducationItem,
  NewsData,
  NewsItem,
  OthersSection,
  PublicationData,
  PublicationUiData,
  ResearchItem,
  SnsLink,
  MenuData,
  TalkItem,
  TopData,
} from "../../types/data";

export const basicData = basic as BasicData;
export const topData = top as TopData;
export const newsData = news as NewsData;
export const careerData = career as CareerItem[];
export const educationData = education as EducationItem[];
export const researchData = research as ResearchItem[];
export const creationData = creation as CreationItem[];
export const awardData = award as AwardData;
export const othersData = others as OthersSection[];
export const snsData = sns as SnsLink[];
export const menuData = menu as MenuData;
export const abbrData = abbr as AbbrData;
export const publicationData = pubs as PublicationData;
export const publicationUiData = publication as PublicationUiData;
export const academicLinksData = academicLinks as AcademicLink[];
export const talksData = talks as TalkItem[];

export type {
  AcademicLink,
  AwardData,
  AbbrData,
  BasicData,
  CareerItem,
  CreationItem,
  EducationItem,
  NewsData,
  NewsItem,
  OthersSection,
  PublicationData,
  PublicationUiData,
  ResearchItem,
  SnsLink,
  MenuData,
  TalkItem,
  TopData,
};
